class UserSearchPermissionChecker {
  hasPermission(currentUser, path) {
    if (!currentUser) {
      return false;
    }

    let { affiliationCd, typeCd: userTypeCd } = currentUser;
    let isAllowed = false;

    if (
      userTypeCd === "IRAD" ||
      userTypeCd === "ISAD"
    ) {
      isAllowed = true;
    }

    return isAllowed;
  }
}

export default new UserSearchPermissionChecker();
